"use strict";
/**
 * @file 地图3D控件
 * @author hedongran
 * @email hdr01@126.com
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Control_1 = tslib_1.__importDefault(require("./Control"));
/**
 * 地图3D控件，可以控制地图的旋转、倾斜，默认位于地图右下角
 * @visibleName NavigationControl 3D控件
 */
var NavigationControl = /** @class */ (function (_super) {
    tslib_1.__extends(NavigationControl, _super);
    function NavigationControl(props) {
        return _super.call(this, props) || this;
    }
    NavigationControl.prototype.getControl = function () {
        return new BMapGL.NavigationControl3D(this.getOptions());
    };
    NavigationControl.prototype.render = function () {
        return null;
    };
    return NavigationControl;
}(Control_1.default));
exports.default = NavigationControl;
